import bescWrappedBSCABI from "../abis/bescWrappedBSCABI.json";
import moneyWrappedBSCABI from "../abis/moneyWrappedBSCABI.json";
import bridgeWrappedTokenABI from "../abis/bridgeWrappedTokenABI.json";
export { bridgeWrappedTokenABI };

// Minimal ERC20 ABI for tokens that require transfer() instead of burn() (e.g. USDC on BSC/ETH)
export const erc20TransferABI = [
  { inputs: [{ name: "to", type: "address" }, { name: "amount", type: "uint256" }], name: "transfer", outputs: [{ type: "bool" }], stateMutability: "nonpayable", type: "function" },
  { inputs: [{ name: "account", type: "address" }], name: "balanceOf", outputs: [{ type: "uint256" }], stateMutability: "view", type: "function" },
  { anonymous: false, inputs: [{ indexed: true, name: "from", type: "address" }, { indexed: true, name: "to", type: "address" }, { indexed: false, name: "value", type: "uint256" }], name: "Transfer", type: "event" },
];

const normalizeAddress = (value) => value?.trim() || undefined;

export const CHAIN_IDS = {
  ETH: 1,
  BSC: 56,
  BESC: 2372,
  RH: 4663,
  XRP: null,
  SOL: null,
};

export const CHAIN_LABELS = {
  ETH: "Ethereum",
  BSC: "BNB Chain",
  BESC: "BESC HyperChain",
  RH: "Robinhood Chain",
  XRP: "XRP Ledger",
  SOL: "Solana",
};

export const CHAIN_SHORT_LABELS = {
  ETH: "ETH",
  BSC: "BSC",
  BESC: "BESC",
  RH: "RH",
  XRP: "XRP",
  SOL: "SOL",
};

export const BRIDGE_TOKENS = {
  WBESC: {
    apiToken: "WBESC",
    label: "BESC",
    available: Boolean(normalizeAddress(process.env.REACT_APP_BSC_WRAPPED_BESC) && normalizeAddress(process.env.REACT_APP_ETH_WRAPPED_BESC)),
    routes: [
      "ETHtoBSC", "BSCtoETH", "ETHtoBESC", "BESCtoETH", "BSCtoBESC", "BESCtoBSC", "RHtoBESC", "BESCtoRH",
      ...(normalizeAddress(process.env.REACT_APP_SOL_WBESC_MINT_ADDRESS) ? [
        "ETHtoSOL", "SOLtoETH", "BSCtoSOL", "SOLtoBSC", "BESCtoSOL", "SOLtoBESC", "RHtoSOL", "SOLtoRH",
      ] : []),
    ],
    chains: {
      ETH: {
        mode: "token",
        symbol: "wBESC",
        decimals: 9,
        address: normalizeAddress(process.env.REACT_APP_ETH_WRAPPED_BESC),
        abi: bescWrappedBSCABI,
        checks: { tradingOpen: true, authorized: true, blacklisted: true, paused: true },
      },
      BSC: {
        mode: "token",
        symbol: "wBESC",
        decimals: 9,
        address: normalizeAddress(process.env.REACT_APP_BSC_WRAPPED_BESC),
        abi: bescWrappedBSCABI,
        checks: { tradingOpen: true, authorized: true, blacklisted: true, paused: true },
      },
      BESC: {
        mode: "native",
        symbol: "BESC",
        decimals: 18,
        receiver: normalizeAddress(process.env.REACT_APP_MINT_CONTROLLER_ADDRESS),
      },
      RH: {
        mode: "token",
        symbol: "WBESC",
        decimals: 9,
        address: normalizeAddress(process.env.REACT_APP_RH_WBESC_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
      SOL: {
        mode: "sol-token",
        symbol: "WBESC",
        decimals: 9,
        mintAddress: normalizeAddress(process.env.REACT_APP_SOL_WBESC_MINT_ADDRESS),
      },
    },
  },
  MONEY: {
    apiToken: "MONEY",
    label: "MONEY",
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BSC_WRAPPED_MONEY) &&
      normalizeAddress(process.env.REACT_APP_ETH_MONEY_TOKEN_ADDRESS) &&
      normalizeAddress(process.env.REACT_APP_BESC_MONEY_TOKEN_ADDRESS)
    ),
    routes: ["ETHtoBSC", "BSCtoETH", "ETHtoBESC", "BESCtoETH", "BSCtoBESC", "BESCtoBSC", "RHtoBESC", "BESCtoRH"],
    chains: {
      ETH: {
        mode: "token",
        symbol: "MONEY",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_ETH_MONEY_TOKEN_ADDRESS),
        abi: moneyWrappedBSCABI,
        checks: {},
      },
      BSC: {
        mode: "token",
        symbol: "MONEY",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BSC_WRAPPED_MONEY),
        abi: moneyWrappedBSCABI,
        checks: {},
      },
      BESC: {
        mode: "token",
        symbol: "MONEY",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BESC_MONEY_TOKEN_ADDRESS),
        abi: moneyWrappedBSCABI,
        checks: {},
      },
      RH: {
        mode: "token",
        symbol: "MONEY",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_RH_MONEY_TOKEN_ADDRESS),
        abi: moneyWrappedBSCABI,
        checks: {},
      },
    },
  },
  WBNB: {
    apiToken: "WBNB",
    label: "WBNB",
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BESC_WBNB_TOKEN_ADDRESS) &&
      normalizeAddress(process.env.REACT_APP_BSC_NATIVE_BRIDGE_RECEIVER)
    ),
    routes: ["BSCtoBESC", "BESCtoBSC"],
    chains: {
      BSC: {
        mode: "native",
        symbol: "BNB",
        decimals: 18,
        receiver: normalizeAddress(process.env.REACT_APP_BSC_NATIVE_BRIDGE_RECEIVER),
      },
      BESC: {
        mode: "token",
        symbol: "WBNB",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BESC_WBNB_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
  WETH: {
    apiToken: "WETH",
    label: "WETH",
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BESC_WETH_TOKEN_ADDRESS) &&
      normalizeAddress(process.env.REACT_APP_ETH_NATIVE_BRIDGE_RECEIVER)
    ),
    routes: ["ETHtoBESC", "BESCtoETH"],
    chains: {
      ETH: {
        mode: "native",
        symbol: "ETH",
        decimals: 18,
        receiver: normalizeAddress(process.env.REACT_APP_ETH_NATIVE_BRIDGE_RECEIVER),
      },
      BESC: {
        mode: "token",
        symbol: "WETH",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BESC_WETH_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
  WXRP: {
    apiToken: "WXRP",
    label: "XRP",
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BESC_WXRP_TOKEN_ADDRESS) &&
      process.env.REACT_APP_XRP_BRIDGE_WALLET_ADDRESS
    ),
    routes: ["XRPtoBESC", "BESCtoXRP"],
    chains: {
      XRP: {
        mode: "xrp-native",
        symbol: "XRP",
        decimals: 6,
        bridgeWalletAddress: process.env.REACT_APP_XRP_BRIDGE_WALLET_ADDRESS,
      },
      BESC: {
        mode: "token",
        symbol: "WXRP",
        decimals: 6,
        address: normalizeAddress(process.env.REACT_APP_BESC_WXRP_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
  WSOL: {
    apiToken: "WSOL",
    label: "SOL",
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BESC_WSOL_TOKEN_ADDRESS) &&
      process.env.REACT_APP_SOL_BRIDGE_WALLET_ADDRESS
    ),
    routes: ["SOLtoBESC", "BESCtoSOL"],
    chains: {
      SOL: {
        mode: "sol-native",
        symbol: "SOL",
        decimals: 9,
        bridgeWalletAddress: process.env.REACT_APP_SOL_BRIDGE_WALLET_ADDRESS,
      },
      BESC: {
        mode: "token",
        symbol: "WSOL",
        decimals: 9,
        address: normalizeAddress(process.env.REACT_APP_BESC_WSOL_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
  WRETH: {
    apiToken: "WRETH",
    label: "WRETH",
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BESC_WRETH_TOKEN_ADDRESS) &&
      normalizeAddress(process.env.REACT_APP_RH_NATIVE_BRIDGE_RECEIVER)
    ),
    routes: ["RHtoBESC", "BESCtoRH"],
    chains: {
      RH: {
        mode: "native",
        symbol: "ETH",
        decimals: 18,
        receiver: normalizeAddress(process.env.REACT_APP_RH_NATIVE_BRIDGE_RECEIVER),
      },
      BESC: {
        mode: "token",
        symbol: "WRETH",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BESC_WRETH_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
  WHOLD: {
    apiToken: "WHOLD",
    label: "HOLD (EARN)",
    // 2.1% bridge fee covers HOLD's 2% reflection tax (owner renounced — cannot be excluded)
    bridgeFeeBps: 210,
    available: Boolean(
      normalizeAddress(process.env.REACT_APP_BESC_WHOLD_TOKEN_ADDRESS) &&
      normalizeAddress(process.env.REACT_APP_ETH_HOLD_TOKEN_ADDRESS)
    ),
    routes: ["ETHtoBESC", "BESCtoETH"],
    chains: {
      ETH: {
        // HOLD has a 2% reflection tax — Transfer event emits post-tax amount (e.g. 98 for 100 sent)
        // sourceTokenTaxBps: widget submits post-tax amount to bridge API on ETH→BESC
        // destTokenTaxBps: bridge's outgoing transfer(user, x) on ETH also triggers 2% reflection
        mode: "erc20-send",
        symbol: "HOLD",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_ETH_HOLD_TOKEN_ADDRESS),
        bridgeReceiverAddress: process.env.REACT_APP_ERC20_BRIDGE_RECEIVER,
        abi: erc20TransferABI,
        checks: {},
        sourceTokenTaxBps: 200,
        destTokenTaxBps: 200,
      },
      BESC: {
        mode: "token",
        symbol: "WHOLD",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BESC_WHOLD_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
  WUSDC: {
    apiToken: "WUSDC",
    label: "USDC",
    available: Boolean(normalizeAddress(process.env.REACT_APP_BESC_WUSDC_TOKEN_ADDRESS)),
    routes: ["BSCtoBESC", "BESCtoBSC", "ETHtoBESC", "BESCtoETH"],
    chains: {
      BSC: {
        // "erc20-send": user calls transfer(bridgeReceiver, amount) — USDC cannot be burned by users
        mode: "erc20-send",
        symbol: "USDC",
        decimals: 18,
        address: normalizeAddress(process.env.REACT_APP_BSC_USDC_ADDRESS),
        bridgeReceiverAddress: process.env.REACT_APP_ERC20_BRIDGE_RECEIVER,
        abi: erc20TransferABI,
        checks: {},
      },
      ETH: {
        mode: "erc20-send",
        symbol: "USDC",
        decimals: 6,
        address: normalizeAddress(process.env.REACT_APP_ETH_USDC_ADDRESS),
        bridgeReceiverAddress: process.env.REACT_APP_ERC20_BRIDGE_RECEIVER,
        abi: erc20TransferABI,
        checks: {},
      },
      BESC: {
        mode: "token",
        symbol: "WUSDC",
        decimals: 6,
        address: normalizeAddress(process.env.REACT_APP_BESC_WUSDC_TOKEN_ADDRESS),
        abi: bridgeWrappedTokenABI,
        checks: {},
      },
    },
  },
};

export const AVAILABLE_TOKEN_KEYS = Object.entries(BRIDGE_TOKENS)
  .filter(([, token]) => token.available)
  .map(([key]) => key);

export const getRouteParts = (direction) => {
  const [sourceChain, destChain] = direction.split("to");
  return { sourceChain, destChain };
};

// tokenMap defaults to the static BRIDGE_TOKENS — pass allTokens from component state
// to include dynamically-registered custom tokens.
export const getRouteConfig = (tokenKey, direction, tokenMap = BRIDGE_TOKENS) => {
  const token = tokenMap[tokenKey];
  if (!token || !token.routes.includes(direction)) {
    return null;
  }

  const { sourceChain, destChain } = getRouteParts(direction);
  const sourceAsset = token.chains[sourceChain];
  const destAsset = token.chains[destChain];

  if (!sourceAsset || !destAsset) {
    return null;
  }

  return {
    token,
    sourceChain,
    destChain,
    sourceAsset,
    destAsset,
    sourceLabel: CHAIN_LABELS[sourceChain] || sourceChain,
    destLabel: CHAIN_LABELS[destChain] || destChain,
    directionLabel: `${sourceAsset.symbol} on ${CHAIN_LABELS[sourceChain]} -> ${destAsset.symbol} on ${CHAIN_LABELS[destChain]}`,
  };
};

export const getExplorerLink = (chain, txHash) => {
  if (!txHash) {
    return "";
  }
  if (chain === "BSC") {
    return `https://bscscan.com/tx/${txHash}`;
  }
  if (chain === "ETH") {
    return `https://etherscan.io/tx/${txHash}`;
  }
  if (chain === "XRP") {
    return `https://livenet.xrpl.org/transactions/${txHash}`;
  }
  if (chain === "SOL") {
    return `https://solscan.io/tx/${txHash}`;
  }
  if (chain === "RH") {
    return `https://robinhoodchain.blockscout.com/tx/${txHash}`;
  }
  return `https://explorer.beschyperchain.com/tx/${txHash}`;
};
